<template>
  <!-- 撮合结算订单详情 -> 任务信息 -->
  <div class="base-card-info">
    <div class="info-card-title">
      任务信息
    </div>

    <div class="custom-base-info">
      <!-- 任务名称 -->
      <div class="item">
        <div class="label">
          任务名称
        </div>
        <div class="value">
          {{ duty.dutyName || '--' }}
        </div>
      </div>
      <!-- 订单编号 -->
      <div class="item">
        <div class="label">
          订单编号
        </div>
        <div class="value">
          {{ duty.orderNo || '--' }}
        </div>
      </div>
      <!-- 订单状态 -->
      <div class="item">
        <div class="label">
          订单状态
        </div>
        <div class="value">
          <custom-tag
            v-if="!isNull(duty.orderStatus)"
            class="!justify-start"
            :type="orderStatus"
            :label="settlementStatusLabel[duty.orderStatus]"
          />
          <span v-else>
            --
          </span>
        </div>
      </div>
      <!-- 服务主体 -->
      <div class="item">
        <div class="label">
          服务主体
        </div>
        <div class="value">
          {{ duty.serverName || '--' }}
        </div>
      </div>
      <!-- 任务类型 -->
      <div class="item">
        <div class="label">
          任务类型
        </div>
        <div class="value">
          {{ duty.dutyTempName || '--' }}
        </div>
      </div>
      <!-- 企业名称 -->
      <div class="item">
        <div class="label">
          企业名称
        </div>
        <div class="value">
          {{ duty.companyName || '--' }}
        </div>
      </div>
      <!-- 订单开始时间 -->
      <div class="item">
        <div class="label">
          订单开始时间
        </div>
        <div class="value">
          {{ duty.startTime || '--' }}
        </div>
      </div>
      <!-- 订单结束时间 -->
      <div class="item">
        <div class="label">
          订单结束时间
        </div>
        <div class="value">
          {{ duty.endTime || '--' }}
        </div>
      </div>
      <!-- 开票科目 -->
      <div class="item">
        <div class="label">
          开票科目
        </div>
        <div class="value">
          {{ duty.invoiceSubName || '--' }}
        </div>
      </div>
      <!-- 支付通道 -->
      <div class="item">
        <div class="label">
          支付通道
        </div>
        <div class="value">
          {{ paymentChannelLabel[duty.payType] || '--' }}
        </div>
      </div>
      <!-- 收款方式 -->
      <div class="item">
        <div class="label">
          收款方式
        </div>
        <div class="value">
          {{ info?.receivedType === 1 ? '支付宝' : info?.receivedType === 0 ? '银行卡' : '--' }}
        </div>
      </div>
      <!-- 空盒子 -->
      <div class="item">
        <div class="label">
          &nbsp;
        </div>
        <div class="value">
          &nbsp;
        </div>
      </div>
      <template v-if="!isServer">
        <!-- 空盒子 -->
        <div class="item">
          <div class="label">
          &nbsp;
          </div>
          <div class="value">
          &nbsp;
          </div>
        </div>
      </template>
    </div>

    <div class="custom-base-info pt-3">
      <!-- 结算说明 -->
      <div class="item">
        <div class="label">
          结算说明
        </div>
        <div class="value !max-w-[760px]">
          {{ duty.remark || '--' }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CustomTag } from '@vue3/components';
import { PropType, computed } from 'vue';
import { ISettlementOrderDetail, settlementStatusStyle, ISettlementOrderDuty, paymentChannelLabel, settlementStatusLabel } from '@core/main/types';
import { isNull } from '@core/tools';

const props = defineProps({
  info: {
    type: Object as PropType<ISettlementOrderDetail>,
    required: true,
  },
  duty: {
    type: Object as PropType<ISettlementOrderDuty>,
    required: true,
  },
  term: {
    type: String as PropType<'server' | 'company' | 'saas' | 'agent'>,
    required: true,
  },
});

const isServer = computed(() => props.term === 'server');
const orderStatus = computed(() => settlementStatusStyle[props.duty.orderStatus] as any);
</script>

<style lang="scss" scoped>
.info-item-label {
  @apply text-[var(--color-text-desc)] pr-4 flex gap-1;

  .svg-icon {
    position: relative;
    top: 2px;
  }
}

.info-item-value {
  @apply text-[var(--color-text-primary)] flex-1;
}

.h-icon {
  @apply text-[var(--color-primary)] ml-1;

  width: 16px !important;
  height: 16px !important;
}
</style>
